import axios from 'axios'

export const api = axios.create({
  baseURL: 'http://api.motecservicos.com.br/V1'
})
